import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import {APP_BASE_HREF} from '@angular/common';
import { serviceInterceptor } from './service.interceptor';
import { environment } from '../environments/environment';

export function loadDynaTraceScript(): () => Promise<void> {
  return (): Promise<void> => {
    return new Promise<void>((resolve) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = environment.dynatraceScript;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => resolve();
      document.head.appendChild(script);
      ((<any>window)._analyticsHelpers ??= { queue: [] }).queue ??= [];
      (<any>window)._analyticsHelpers.site = 'RogersBank';
      if (!(<any>window)._trackData) {
        (<any>window)._trackData = (payload: any) =>
          (<any>window)._analyticsHelpers.queue.push(payload);
      }
    });
  };
}
export const appConfig: ApplicationConfig = {
  // providers: [
  //   provideRouter(routes),
  //   provideClientHydration(),
  //   provideAnimationsAsync(),
  // ],
  providers: [
    provideRouter(routes),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: serviceInterceptor,
      multi: true,
    },
    { provide: APP_INITIALIZER, useFactory: loadDynaTraceScript, multi: true },
 
    // {provide: APP_BASE_HREF, useValue: '/internalportal/cli/'},
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    importProvidersFrom(HttpClientModule)
  ]
};
